import { triggerAnalyticsEvent } from "./analytics-helpers";

export async function gtmTrackEventData(triggerKey, data = {}) {
  const triggerData = {
    data
  };

  triggerAnalyticsEvent(triggerKey, triggerData);
}